import { openTelegramLink } from '@tma.js/sdk';

/**
 * Открывает профиль в Telegram.
 *
 * Проверка isAvailable() обязательна: вне Telegram (сайт открыт прямо
 * в браузере, дев-режим) метод молча ничего не делает — не бросает
 * исключение, а просто не срабатывает. Без явной проверки ссылка
 * оказалась бы мёртвой, и это было бы незаметно.
 *
 * isAvailable() учитывает и то, что окружение — Mini App, и что
 * клиент поддерживает метод.
 */
export function openTelegramProfile(username: string): void {
  const url = `https://t.me/${username}`;

  if (openTelegramLink.isAvailable()) {
    openTelegramLink(url);
    return;
  }
  window.open(url, '_blank', 'noopener');
}
